<template>
    <div class="category-page">
        <div class="loaderIcon" v-if="!loaded"></div>
        <div v-else>
            <IntroSection :imageUrl="introImageUrl"
                          :titlePrefix="titlePrefix"
                          :title="title"
                          :body="body"></IntroSection>
            <vue-picture-swipe class="gallery" :items="items"></vue-picture-swipe>
        </div>
    </div>
</template>

<script>
    import IntroSection from './IntroSection'
    import VuePictureSwipe from 'vue-picture-swipe'

    export default {
        name: 'CategoryPage',
        components: {
            IntroSection,
            'vue-picture-swipe': VuePictureSwipe,
        },
        props: {
            categoryJsonUrl : String
        },
        created: function () {
            this.reloadJson();
        },
        watch: {
            categoryJsonUrl: function(newVal, oldVal) {
                this.loaded = false;
                this.items = [];
                this.introImageUrl = "";
                this.titlePrefix = "";
                this.title = "";
                this.makeupType = "";
                this.body = "";
                this.reloadJson();
            }
        },
        methods: {
            reloadJson: function() {
                let url = this.categoryJsonUrl;
                if (!url) {
                    this.loaded = true;
                    return;
                }
                if (!url.startsWith('/') && !url.startsWith('http')) {
                    url = '/' + url;
                }
                fetch(url)
                    .then((response) => {
                        if (!response.ok) throw new Error('HTTP error ' + response.status);
                        return response.json();
                    })
                    .then((json) => {
                        this.items = json.items || [];
                        this.introImageUrl = json.introImageUrl || "";
                        this.titlePrefix = json.titlePrefix || "";
                        this.title = json.title || "";
                        this.makeupType = json.makeupType || "איפור כלות";
                        this.body = json.body || "";
                        this.loaded = true;
                    })
                    .catch((err) => {
                        console.error('Error loading category JSON:', err);
                        this.loaded = true;
                    });
            }
        },
        data() {
            return {
                items: [],
                introImageUrl: "",
                titlePrefix: "",
                title: "",
                body: "",
                makeupType: "איפור כלות",
                loaded: false
            }
        }
    }
</script>

<style>
    .spad {
        padding-top: 60px;
        padding-bottom: 115px;
    }

    .intro-text {
        padding-right: 30px;
    }
</style>
